module.exports = __webpack_public_path__ + "static/media/07.d5d14f36.mp3";